module.exports = __webpack_public_path__ + "img/2025-07-21b_3.80d524cb.jpg";